import { useState, useEffect } from 'react'
import type {
  MetadataGenerator,
  Metadata,
} from '../contracts/metadataGenerator'
import type { ImageFile } from '../contracts/uploadService'
import type { ImageContext } from '../contracts/metadataGenerator'
import { DesktopMetadataEditor } from './DesktopMetadataEditor'
import { MobileMetadataEditor } from './MobileMetadataEditor'

interface MetadataEditorProps {
  metadataGenerator: MetadataGenerator
  images: ImageFile[]
  existingMetadata: Record<string, Metadata>
  imageContext: ImageContext
  onMetadataUpdate: (imageId: string, metadata: Metadata) => void
  isBatchGenerating: boolean
  batchProgress: { current: number; total: number }
  onBatchGeneratingChange: (generating: boolean) => void
  onBatchProgressChange: (progress: { current: number; total: number }) => void
  onAddMoreImages: (files: FileList) => void
  onDeleteImage: (imageId: string) => void
  onNavigateToExport?: () => void
}

export function MetadataEditor(props: MetadataEditorProps) {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 1024) // lg breakpoint
    }

    // Check initial state
    checkIsMobile()

    // Add event listener for window resize
    window.addEventListener('resize', checkIsMobile)

    // Cleanup
    return () => window.removeEventListener('resize', checkIsMobile)
  }, [])

  // Use the appropriate component based on screen size
  if (isMobile) {
    return <MobileMetadataEditor {...props} />
  } else {
    return <DesktopMetadataEditor {...props} />
  }
}